import React from "react";
import { ArrowUpRight, Instagram, Linkedin, Twitter, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] border-t border-white/5 pt-20 pb-8 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#C9A227]/70 to-transparent" />
      <div className="aurora bg-[#047857] w-[420px] h-[420px] -bottom-40 -right-40" style={{opacity:0.14}} />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="relative w-11 h-11 rounded-xl border border-[#C9A227]/40 grid place-items-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#C9A227]/30 to-[#047857]/20" />
                <span className="relative font-bold text-[#F4D983]">S</span>
              </div>
              <div>
                <div className="font-semibold">SYR <span className="text-gold-gradient">Mediaworks</span></div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-white/50">Sync Your Rise</div>
              </div>
            </div>
            <p className="mt-6 text-white/55 leading-relaxed max-w-md">
              Driving business growth through data, technology and performance. A DPIIT
              recognized startup empowering Bharat and building Digital India.
            </p>
            <div className="mt-6 flex gap-3">
              {[Instagram, Linkedin, Twitter, Facebook, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 grid place-items-center rounded-lg border border-white/10 text-white/60 hover:text-[#F4D983] hover:border-[#C9A227]/40 transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.28em] text-[#F4D983] mb-4">Company</div>
            <ul className="space-y-3 text-white/60">
              {[["About","#about"],["Ecosystem","#ecosystem"],["Careers","#careers"],["Contact","#contact"]].map(([l,h])=>(
                <li key={l}><a href={h} className="hover:text-white">{l}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.28em] text-[#F4D983] mb-4">Services</div>
            <ul className="space-y-3 text-white/60">
              {["Performance Marketing","AI & Software","Branding & Web","Affiliate Network","Government"].map(l=>(
                <li key={l}><a href="#services" className="hover:text-white">{l}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.28em] text-[#F4D983] mb-4">Reach Us</div>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>business@syr.co.in</li>
              <li>www.syr.co.in</li>
            </ul>
            <a href="https://wa.me/917610512615" target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-[#F4D983] hover:text-white transition-colors">
              Start Partnership <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/40">
          <div>© {new Date().getFullYear()} SYR Mediaworks Private Limited. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <span className="flex items-center gap-2"><span className="divider-dot" /> DPIIT Recognized Startup</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
